export function scheduleSummary(due: string, reminder: string, recurrence: string, calendarCount: number): string {
  return [due && `Due ${due}`, reminder && `remind ${reminder}`, recurrence, calendarCount && `${calendarCount} calendar${calendarCount === 1 ? "" : "s"}`].filter(Boolean).join(" · ") || "No schedule";
}

export function extraScheduleSummary(reminder: string, recurrence: string, calendarCount: number, timed: boolean, estimated: boolean): string {
  return [timed && "Timed", estimated && "Estimate", reminder, recurrence, calendarCount && `${calendarCount} calendar${calendarCount === 1 ? "" : "s"}`].filter(Boolean).join(" · ");
}

export function organizationSummary(collection: string, cycle: string): string {
  return `${collection || "No collection"} · ${cycle || "Backlog"}`;
}

export function collaborationSummary(assignee: string, assigneeCount: number, blockerCount: number): string {
  return [assignee, assigneeCount > 1 && `+${assigneeCount - 1}`, blockerCount && `${blockerCount} blocker${blockerCount === 1 ? "" : "s"}`].filter(Boolean).join(" · ");
}
